import { createContext, useContext } from 'react';

// An action the host adds after the card's status, such as folding an opened
// settled card back to its row. `focus` takes focus as it appears, as Restore does
// on a card the user just dismissed
export type HostStatusAction = {
  label: string;
  run: () => void;
  focus?: boolean;
};

export const HostStatusActionContext = createContext<
  HostStatusAction | undefined
>(undefined);

export const useHostStatusAction = () => useContext(HostStatusActionContext);
